import React from 'react';
import { get } from 'lodash';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberInfoCommunicationSettings as MemberInfoCommunicationSettingsView } from 'ui/views/widgets/memberInfoCommunicationSettings';
import { MemberInfoCommunicationSettingsService } from 'services/memberInfoCommunicationSettings';
import { withRouter } from 'react-router-dom';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberInfoCommunicationSettings } from 'ui/containers/MemberInfoCommunicationSettings';
 *
 * // render
 * <MemberInfoCommunicationSettings propName='propValue'/>
 */
export class _MemberInfoCommunicationSettings extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // Member Info Communication Settings Service
        this.memberInfoCommunicationSettingsService = new MemberInfoCommunicationSettingsService();

        // Member Info Communication Settings data fetch
        this.fetchComponentData();
    }

    /**
     * @desc Fetch member Info Communication Settings.
     */
     async fetchComponentData() {
        log.debug( 'MemberInfoCommunicationSettings.fetchComponentData()' );

        // cancel ongoing request
        this.memberInfoCommunicationSettingsService.cancel();

        try {
            const { status, data }  = await this.memberInfoCommunicationSettingsService.fetchData( {
                url: this.props.widget.url,
                requestPayload: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }
        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resources.
     */
    componentWillUnmount() {
        this.memberInfoCommunicationSettingsService.cancel(); // cancel ongoing requests
    }

    /******************************************** */
    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberInfoCommunicationSettingsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                location={ this.props.location }
            />
        );
    }
}

// set display name
_MemberInfoCommunicationSettings.displayName = 'MemberInfoCommunicationSettings';

// set default props
_MemberInfoCommunicationSettings.defaultProps = {};

// prop types
_MemberInfoCommunicationSettings.propTypes = {};

// wrap with router
export const MemberInfoCommunicationSettings = withRouter( _MemberInfoCommunicationSettings );
